// frontend/src/services/favoritesService.js
import api from './api';

const favoritesService = {
  getAll: () => api.get('/grupos-favoritos/'),
  
  create: (data) => api.post('/grupos-favoritos/', data),

  update: (id, data) => api.patch(`/grupos-favoritos/${id}/`, data),
  
  delete: (id) => api.delete(`/grupos-favoritos/${id}/`),
};

export default favoritesService;